module.exports = __webpack_public_path__ + "img/200706_homeLoading_grey4.ca246f43.png";